import { Observable, of } from 'rxjs';
import { FilePickerAdapter, UploadResponse, FilePreviewModel} from 'ngx-awesome-uploader';

export class GradPilotFilePickerAdapter extends FilePickerAdapter {
  constructor() {
    super();
  }
  public uploadFile(fileItem: FilePreviewModel): Observable<UploadResponse> {
    return of();
  }
  public removeFile(fileItem: FilePreviewModel): Observable<any> {
    return of(true);
  }
}
